import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as VegetationIconTab} from '../../assets/vegetationIcon.svg';

interface HeaderIconProps extends SvgIconProps {
  selected: boolean;
  baseColor?: string;
}

const VegetationIcon: React.FC<HeaderIconProps> = (props: HeaderIconProps) => {
  const {selected, baseColor, ...svgProps} = props;

  return (
    <SvgIcon
      {...svgProps}
      component={VegetationIconTab}
      style={{
        fillOpacity: props.baseColor ? '1' : props.selected ? '1' : '0.5',
        color: props.baseColor && !props.selected ? props.baseColor : '#FFFFFF',
      }}
      viewBox='0 0 22 16'
    />
  );
};

export default VegetationIcon;
